function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { InfaceEnv } from '@inface-sdk/common';
import { inpayEnv } from '../common/env';
import { inpayLocale } from '../common/locale';
import { alltemApiForWeb, stampApiForWeb, diPayForWeb, purchaseHistory } from '../common/api';
import { UX_MODE, IAS_WEB_TOKEN } from '../common/constant';
import sdkUtil from '../common/util';
import { ErrorCode, StampError } from '../common/error/error-code.enum';

/**
 *  Inpay SDK class 중 외부에 노출 할 Web API Module 을 생성합니다.
 * @returns {InpayWebSDKApi}
 */
export default function createSdkApis() {
  return {
    initialize: function initialize(_ref) {
      var env = _ref.env,
        locale = _ref.locale;
      var currentEnv = Object.values(inpayEnv.ENV_ENUM).includes(env) ? env : inpayEnv.ENV_ENUM.LIVE;
      inpayEnv.setEnv(currentEnv);
      if (locale) {
        InfaceEnv.setupEnv({
          locale: locale
        });
      }
    },
    getServiceProducts: function () {
      var _getServiceProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _window$inface, _window$inface2;
        var _ref2,
          gid,
          _ref2$status,
          status,
          itemName,
          itemNo,
          pid,
          _ref2$page,
          page,
          _ref2$size,
          size,
          stringGid,
          arrayStatus,
          serviceCode,
          validWebToken,
          body,
          result,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, gid = _ref2.gid, _ref2$status = _ref2.status, status = _ref2$status === void 0 ? ['SALE'] : _ref2$status, itemName = _ref2.itemName, itemNo = _ref2.itemNo, pid = _ref2.pid, _ref2$page = _ref2.page, page = _ref2$page === void 0 ? 1 : _ref2$page, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? 20 : _ref2$size;
              stringGid = gid || ((_window$inface = window.inface) === null || _window$inface === void 0 || (_window$inface = _window$inface.auth) === null || _window$inface === void 0 ? void 0 : _window$inface.gid);
              arrayStatus = Array.isArray(status) ? status : [status];
              _context.next = 5;
              return alltemApiForWeb.convertServiceCodeByGid(stringGid);
            case 5:
              serviceCode = _context.sent;
              validWebToken = ((_window$inface2 = window.inface) === null || _window$inface2 === void 0 || (_window$inface2 = _window$inface2.auth) === null || _window$inface2 === void 0 ? void 0 : _window$inface2.webToken) || '';
              body = {
                gid: stringGid,
                status: arrayStatus,
                itemName: itemName,
                itemNo: itemNo,
                pid: pid,
                page: page,
                size: size,
                param: {
                  size: size,
                  page: page
                }
              };
              _context.next = 10;
              return alltemApiForWeb.getServiceProductsByPidList({
                body: body,
                serviceCode: serviceCode
              });
            case 10:
              result = _context.sent;
              return _context.abrupt("return", alltemApiForWeb.parseServiceProductsList({
                result: result,
                webToken: validWebToken,
                gid: stringGid
              }));
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getServiceProducts() {
        return _getServiceProducts.apply(this, arguments);
      }
      return getServiceProducts;
    }(),
    /**
     * PID를 기준으로 상품 목록을 Alltem으로부터 전달받아 반환합니다
     * 동일=product_list
     * @returns Product list
     */
    getProducts: function () {
      var _getProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _window$inface3, _window$inface4;
        var _ref3,
          productIds,
          gid,
          webToken,
          validGid,
          validProductIds,
          validWebToken,
          message,
          serviceCode,
          param,
          result,
          productModelList,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref3 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, productIds = _ref3.productIds, gid = _ref3.gid, webToken = _ref3.webToken;
              validGid = gid || ((_window$inface3 = window.inface) === null || _window$inface3 === void 0 || (_window$inface3 = _window$inface3.auth) === null || _window$inface3 === void 0 ? void 0 : _window$inface3.gid);
              validProductIds = Array.isArray(productIds) ? productIds : [productIds];
              validWebToken = webToken || ((_window$inface4 = window.inface) === null || _window$inface4 === void 0 || (_window$inface4 = _window$inface4.auth) === null || _window$inface4 === void 0 ? void 0 : _window$inface4.webToken);
              if (validWebToken) {
                _context2.next = 8;
                break;
              }
              message = 'Inpay: web token is undefined. please signin with insign service.';
              console.error(message);
              return _context2.abrupt("return", {
                error: message
              });
            case 8:
              if (!(!validProductIds || validProductIds.some(function (v) {
                return !v;
              }) || validProductIds.length <= 0)) {
                _context2.next = 11;
                break;
              }
              console.error('Inpay: productIds is must required value on getProducts and cannot allow null value in array item.');
              return _context2.abrupt("return", []);
            case 11:
              _context2.next = 13;
              return alltemApiForWeb.convertServiceCodeByGid(validGid, inpayEnv.getEnv());
            case 13:
              serviceCode = _context2.sent;
              param = {
                itemPidList: validProductIds.map(function (item) {
                  return String(item);
                })
              };
              _context2.next = 17;
              return alltemApiForWeb.getProducts({
                param: param,
                serviceCode: serviceCode
              });
            case 17:
              result = _context2.sent;
              _context2.next = 20;
              return alltemApiForWeb.parseItemListModel(result, validWebToken, validGid);
            case 20:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 23;
                break;
              }
              _context2.t0 = [];
            case 23:
              productModelList = _context2.t0.map(function (item) {
                var resItem = result._embedded.pIDItemList.find(function (pIDitem) {
                  return pIDitem.pid === item.productId;
                });
                // eslint-disable-next-line no-param-reassign
                item.itemProperties = resItem.item.itemProperties || {};
                // eslint-disable-next-line no-param-reassign
                item.prices = resItem.prices;
                return item;
              });
              return _context2.abrupt("return", _toConsumableArray(productModelList));
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getProducts() {
        return _getProducts.apply(this, arguments);
      }
      return getProducts;
    }(),
    /**
     * 아이템의 상세정보를 리턴합니다.
     * @param {*} param0
     * @returns
     */
    getProductDetail: function () {
      var _getProductDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _window$inface5;
        var _ref4,
          productId,
          gid,
          validGid,
          serviceCode,
          result,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref4 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, productId = _ref4.productId, gid = _ref4.gid;
              validGid = gid || ((_window$inface5 = window.inface) === null || _window$inface5 === void 0 || (_window$inface5 = _window$inface5.auth) === null || _window$inface5 === void 0 ? void 0 : _window$inface5.gid);
              if (productId) {
                _context3.next = 5;
                break;
              }
              console.error('Inpay: productId is must required value on getProductDetail.');
              return _context3.abrupt("return", []);
            case 5:
              _context3.next = 7;
              return alltemApiForWeb.convertServiceCodeByGid(validGid, inpayEnv.getEnv());
            case 7:
              serviceCode = _context3.sent;
              _context3.next = 10;
              return alltemApiForWeb.getProductDetail({
                serviceCode: serviceCode,
                productId: productId
              });
            case 10:
              result = _context3.sent;
              return _context3.abrupt("return", result);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getProductDetail() {
        return _getProductDetail.apply(this, arguments);
      }
      return getProductDetail;
    }(),
    /**
     * 다건 구매 프로세스를 진행합니다.
     */
    purchaseProducts: function () {
      var _purchaseProducts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this$billingPurchase;
        var _ref5,
          uxMode,
          returnUrl,
          _ref5$products,
          products,
          clientId,
          gid,
          gsid,
          gcid,
          worldId,
          webToken,
          stampEnv,
          inflowPath,
          inflowTxId,
          locale,
          _ref5$gameMeta,
          gameMeta,
          _ref5$servicePayload,
          servicePayload,
          currency,
          presentFlag,
          presentMeta,
          issueToken,
          _ref5$onChangeStatus,
          onChangeStatus,
          error,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref5 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, uxMode = _ref5.uxMode, returnUrl = _ref5.returnUrl, _ref5$products = _ref5.products, products = _ref5$products === void 0 ? [] : _ref5$products, clientId = _ref5.clientId, gid = _ref5.gid, gsid = _ref5.gsid, gcid = _ref5.gcid, worldId = _ref5.worldId, webToken = _ref5.webToken, stampEnv = _ref5.stampEnv, inflowPath = _ref5.inflowPath, inflowTxId = _ref5.inflowTxId, locale = _ref5.locale, _ref5$gameMeta = _ref5.gameMeta, gameMeta = _ref5$gameMeta === void 0 ? {} : _ref5$gameMeta, _ref5$servicePayload = _ref5.servicePayload, servicePayload = _ref5$servicePayload === void 0 ? {} : _ref5$servicePayload, currency = _ref5.currency, presentFlag = _ref5.presentFlag, presentMeta = _ref5.presentMeta, issueToken = _ref5.issueToken, _ref5$onChangeStatus = _ref5.onChangeStatus, onChangeStatus = _ref5$onChangeStatus === void 0 ? function () {} : _ref5$onChangeStatus;
              if (Array.isArray(products)) {
                _context4.next = 5;
                break;
              }
              error = 'Inpay: products must be array type';
              console.error(error);
              return _context4.abrupt("return", {
                error: error
              });
            case 5:
              return _context4.abrupt("return", this.billingPurchase((_this$billingPurchase = {
                uxMode: uxMode,
                returnUrl: returnUrl,
                clientId: clientId,
                _products_: products,
                webToken: webToken,
                gid: gid,
                gsid: gsid,
                gcid: gcid,
                worldId: worldId
              }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_this$billingPurchase, "webToken", webToken), "stampEnv", stampEnv), "inflowPath", inflowPath), "inflowTxId", inflowTxId), "locale", locale), "gameMeta", gameMeta), "servicePayload", servicePayload), "currency", currency), "_issueToken_", issueToken), "_presentFlag_", presentFlag), _defineProperty(_defineProperty(_this$billingPurchase, "_presentMeta_", presentMeta), "onChangeStatus", onChangeStatus))));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function purchaseProducts() {
        return _purchaseProducts.apply(this, arguments);
      }
      return purchaseProducts;
    }(),
    /**
     * 단건 구매 프로세스를 진행합니다.
     */
    billingPurchase: function () {
      var _billingPurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _window$inface6, _window$inface7, _window$inface8;
        var _ref6,
          uxMode,
          returnUrl,
          clientId,
          _products_,
          productId,
          quantity,
          gid,
          gsid,
          gcid,
          worldId,
          webToken,
          stampEnv,
          inflowPath,
          inflowTxId,
          locale,
          _ref6$gameMeta,
          gameMeta,
          _ref6$servicePayload,
          servicePayload,
          currency,
          _ref6$onChangeStatus,
          onChangeStatus,
          _issueToken_,
          _presentFlag_,
          _presentMeta_,
          validGid,
          insignEnv,
          validGsid,
          validGcid,
          validWorldId,
          validWebToken,
          validStampEnv,
          validQuantity,
          validInflowPath,
          validInflowTxId,
          validLocale,
          validCurrency,
          isMpProcess,
          validUxMode,
          message,
          validReturnUrl,
          _message,
          validClientId,
          gtableInfo,
          _message2,
          _message3,
          _message4,
          _message5,
          market,
          _message6,
          stampIssueData,
          isValid,
          _message7,
          _ref7,
          guid,
          world_id,
          _gcid,
          _message8,
          _message9,
          stampTransaction,
          issueHeader,
          _stampTransaction,
          stamp_id,
          channel_id,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _ref6 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, uxMode = _ref6.uxMode, returnUrl = _ref6.returnUrl, clientId = _ref6.clientId, _products_ = _ref6._products_, productId = _ref6.productId, quantity = _ref6.quantity, gid = _ref6.gid, gsid = _ref6.gsid, gcid = _ref6.gcid, worldId = _ref6.worldId, webToken = _ref6.webToken, stampEnv = _ref6.stampEnv, inflowPath = _ref6.inflowPath, inflowTxId = _ref6.inflowTxId, locale = _ref6.locale, _ref6$gameMeta = _ref6.gameMeta, gameMeta = _ref6$gameMeta === void 0 ? {} : _ref6$gameMeta, _ref6$servicePayload = _ref6.servicePayload, servicePayload = _ref6$servicePayload === void 0 ? {} : _ref6$servicePayload, currency = _ref6.currency, _ref6$onChangeStatus = _ref6.onChangeStatus, onChangeStatus = _ref6$onChangeStatus === void 0 ? function () {} : _ref6$onChangeStatus, _issueToken_ = _ref6._issueToken_, _presentFlag_ = _ref6._presentFlag_, _presentMeta_ = _ref6._presentMeta_;
              validGid = gid || ((_window$inface6 = window.inface) === null || _window$inface6 === void 0 || (_window$inface6 = _window$inface6.auth) === null || _window$inface6 === void 0 ? void 0 : _window$inface6.gid);
              insignEnv = ((_window$inface7 = window.inface) === null || _window$inface7 === void 0 || (_window$inface7 = _window$inface7.auth) === null || _window$inface7 === void 0 ? void 0 : _window$inface7.env) || 'live';
              validGsid = gsid || 1; // fake gsid
              validGcid = gcid || undefined;
              validWorldId = worldId || undefined;
              validWebToken = webToken || ((_window$inface8 = window.inface) === null || _window$inface8 === void 0 || (_window$inface8 = _window$inface8.auth) === null || _window$inface8 === void 0 ? void 0 : _window$inface8.webToken);
              validStampEnv = stampEnv || 'live';
              validQuantity = Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
              validInflowPath = inflowPath || '';
              validInflowTxId = inflowTxId || '';
              validLocale = locale || '';
              validCurrency = currency || '';
              isMpProcess = Array.isArray(_products_);
              validUxMode = uxMode || 'newTab';
              if (['newTab', 'redirect'].includes(validUxMode)) {
                _context5.next = 19;
                break;
              }
              message = 'Inpay: uxMode is must be newTab or redirect';
              console.error(message);
              return _context5.abrupt("return", {
                error: message
              });
            case 19:
              validReturnUrl = returnUrl || '';
              if (!(validUxMode === 'redirect' && !validReturnUrl)) {
                _context5.next = 24;
                break;
              }
              _message = 'Inpay: returnUrl is undefined. please set returnUrl value on redirect mode.';
              console.error(_message);
              return _context5.abrupt("return", {
                error: _message
              });
            case 24:
              validClientId = clientId;
              if (validClientId) {
                _context5.next = 34;
                break;
              }
              _context5.next = 28;
              return InfaceEnv.GTABLE.get(validGid, insignEnv);
            case 28:
              gtableInfo = _context5.sent;
              validClientId = gtableInfo.game_client_id;
              if (validClientId) {
                _context5.next = 34;
                break;
              }
              _message2 = 'Inpay: client id is undefined. Check Client value in parameter or gtable of inface console.';
              console.error(_message2);
              return _context5.abrupt("return", {
                error: _message2
              });
            case 34:
              if (validWebToken) {
                _context5.next = 38;
                break;
              }
              _message3 = 'Inpay: web token is undefined. please signin with insign service.';
              console.error(_message3);
              return _context5.abrupt("return", {
                error: _message3
              });
            case 38:
              if (!(isMpProcess && _products_.length < 1)) {
                _context5.next = 44;
                break;
              }
              _message4 = 'Inpay: products is a required field for purchase.';
              console.error(_message4);
              return _context5.abrupt("return", {
                error: _message4
              });
            case 44:
              if (!(!isMpProcess && !productId)) {
                _context5.next = 48;
                break;
              }
              _message5 = 'Inpay: itemPID is must required value on purchase';
              console.error(_message5);
              return _context5.abrupt("return", {
                error: _message5
              });
            case 48:
              if (inpayLocale.isSupportedMarket(validWebToken, inpayLocale.FEATURE_ENUM.PAYMENT)) {
                _context5.next = 53;
                break;
              }
              market = inpayLocale.getMarketFromWebToken(validWebToken);
              _message6 = "Inpay: ".concat(market, " is not supported market");
              console.error(_message6);
              return _context5.abrupt("return", {
                error: _message6
              });
            case 53:
              stampIssueData = _objectSpread(_objectSpread({
                issue_type: 'NORMAL',
                client_id: validClientId || 'MzMyNjk0MTU5',
                token: validWebToken,
                token_type: IAS_WEB_TOKEN
              }, isMpProcess ? {} : {
                product_id: productId
              }), {}, {
                game_meta: sdkUtil.encodeToBase64(gameMeta),
                service_payload: sdkUtil.encodeToBase64(servicePayload),
                stamp_payload: btoa(JSON.stringify({
                  payment_location: window.location.href,
                  stampEnv: validStampEnv,
                  currency: validCurrency,
                  character_id: ''
                })),
                inflow_path: validInflowPath,
                inflow_tx_id: validInflowTxId,
                locale: validLocale
              });
              if (!isMpProcess && validQuantity) {
                // quantity는 mq 아이템에 대해서만 사용가능 또한 자연수만 쓸수있다.
                stampIssueData.quantity = quantity;
              }

              // for MP
              if (!isMpProcess) {
                _context5.next = 77;
                break;
              }
              isValid = _products_.every(function (product) {
                var product_id = product.product_id,
                  quantity = product.quantity,
                  product_name = product.product_name,
                  price = product.price,
                  discount_flag = product.discount_flag;
                if (!product_id || !quantity) {
                  return false;
                }
                if (inflowPath === 'nisms') {
                  if (!product_name || !price || !discount_flag) {
                    return false;
                  }
                }
                return true;
              });
              if (isValid) {
                _context5.next = 61;
                break;
              }
              _message7 = 'Inpay: _products_ is invalid format';
              console.error(_message7);
              return _context5.abrupt("return", {
                error: _message7
              });
            case 61:
              stampIssueData.products = sdkUtil.encodeToBase64(_products_);
              stampIssueData.issue_token = _issueToken_ || '';
              if (!_presentFlag_) {
                _context5.next = 73;
                break;
              }
              stampIssueData.present_flag = 'Y';
              _ref7 = _presentMeta_ || {}, guid = _ref7.guid, world_id = _ref7.world_id, _gcid = _ref7.gcid;
              if (!(!_presentMeta_ || !guid || !world_id || !_gcid)) {
                _context5.next = 70;
                break;
              }
              _message8 = "Inpay: _presentMeta_ is ".concat(_presentMeta_ ? '' : 'missing ', " required field if _presentFlag_ is true");
              console.error(_message8);
              return _context5.abrupt("return", {
                error: _message8
              });
            case 70:
              stampIssueData.present_meta = sdkUtil.encodeToBase64(_presentMeta_);
              _context5.next = 77;
              break;
            case 73:
              if (!_presentMeta_) {
                _context5.next = 77;
                break;
              }
              _message9 = "Inpay: _presentFlag_ must be truw if _presentMeta_ is passed";
              console.error(_message9);
              return _context5.abrupt("return", {
                error: _message9
              });
            case 77:
              _context5.prev = 77;
              issueHeader = {
                gid: validGid,
                gsid: validGsid
              };
              if (validGcid) {
                issueHeader.gcid = validGcid;
              }
              if (validWorldId) {
                issueHeader.world_id = validWorldId;
              }
              _context5.next = 83;
              return stampApiForWeb.issue({
                param: stampIssueData,
                header: issueHeader,
                webToken: validWebToken
              });
            case 83:
              stampTransaction = _context5.sent;
              _context5.next = 89;
              break;
            case 86:
              _context5.prev = 86;
              _context5.t0 = _context5["catch"](77);
              return _context5.abrupt("return", _context5.t0);
            case 89:
              _stampTransaction = stampTransaction, stamp_id = _stampTransaction.stamp_id, channel_id = _stampTransaction.channel_id; // 웹버전 응답 결과에 direct_payment_token 값이 없음 확인 필요
              return _context5.abrupt("return", {
                payurl: diPayForWeb.createUrl({
                  webToken: validWebToken,
                  env: validStampEnv,
                  stampTransaction: stampTransaction,
                  channelId: channel_id,
                  uxMode: validUxMode,
                  returnUrl: validReturnUrl
                }),
                currentRetryCount: 0,
                waitingForHandler: null,
                refreshBrakeHandler: function refreshBrakeHandler(event) {
                  event.preventDefault();
                  var feedBackMessage = '현재 결제 진행중입니다. 결제 진행중 페이지를 떠나면, 결제에 문제가 발생할 수 있습니다. 그래도 페이지를 떠나시겠습니까?';
                  // eslint-disable-next-line no-param-reassign
                  event.returnValue = feedBackMessage;
                  return feedBackMessage;
                },
                status_all: {
                  READY: 'READY',
                  CANCEL: 'CANCEL',
                  FAIL: 'FAIL',
                  PAYMENT: 'PAYMENT',
                  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
                  ITEM_DELIVERY: 'ITEM_DELIVERY',
                  ITEM_DELIVERY_COMPLETED: 'ITEM_DELIVERY_COMPLETED'
                },
                status: 'READY',
                changePaymentStatus: function changePaymentStatus(_state) {
                  var dataMeta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  this.status = _state;
                  onChangeStatus(_state, dataMeta || {});
                  if ([this.status_all.READY, this.status_all.CANCEL, this.status_all.FAIL, this.status_all.ITEM_DELIVERY_COMPLETED].includes(_state)) {
                    if ([this.status_all.CANCEL].includes(_state) && this.waitingForHandler) {
                      clearInterval(this.waitingForHandler);
                      this.waitingForHandler = null;
                    }
                    window.removeEventListener('beforeunload', this.refreshBrakeHandler, {
                      capture: true
                    });
                  } else {
                    window.addEventListener('beforeunload', this.refreshBrakeHandler, {
                      capture: true
                    });
                  }
                },
                waitingFor: function waitingFor(next) {
                  var _this = this;
                  if (this.waitingForHandler != null) {
                    return;
                  }
                  var maxRetryCount = 300; // 15분
                  var termTimevalue = 3000;
                  var statusBody = {
                    stamp_id: stamp_id,
                    token: validWebToken
                  };
                  this.waitingForHandler = setInterval(function () {
                    stampApiForWeb.getStatus({
                      param: statusBody,
                      header: {
                        gid: validGid,
                        gsid: validGsid
                      }
                    }).then(function (stateResponse) {
                      if (!stateResponse || stateResponse.error) {
                        throw stateResponse;
                      }
                      if (stateResponse) {
                        if (Number.isInteger(stateResponse.tx_status)) {
                          if (stampApiForWeb.isErrorTxStatus(stateResponse.tx_status)) {
                            throw new Error(_objectSpread({
                              tx_status: stateResponse.tx_status
                            }, stateResponse));
                          }
                        }
                        if (next && !next(stateResponse)) {
                          clearInterval(_this.waitingForHandler);
                          _this.waitingForHandler = null;
                          return;
                        }
                      } else {
                        throw new Error('invalid response.');
                      }
                      _this.currentRetryCount += 1;
                      if (_this.currentRetryCount >= maxRetryCount && _this.status !== _this.status_all.CANCEL) {
                        clearInterval(_this.waitingForHandler);
                        _this.waitingForHandler = null;
                        _this.changePaymentStatus(_this.status_all.CANCEL);
                      }
                    }).catch(function (e) {
                      _this.changePaymentStatus(_this.status_all.FAIL, {
                        error: e
                      });
                      clearInterval(_this.waitingForHandler);
                      _this.waitingForHandler = null;
                    });
                  }, termTimevalue);
                },
                payment: function payment() {
                  var _this2 = this;
                  if (this.status === this.status_all.READY) {
                    this.changePaymentStatus(this.status_all.PAYMENT);
                    this.waitingFor(function (_ref8) {
                      var tx_status = _ref8.tx_status;
                      if ([stampApiForWeb.STAMP_STATUS_CODE.ISSUED].includes(tx_status)) {
                        // 지정한 STATUS에서 상태 지속 점검
                        return true;
                      }
                      _this2.changePaymentStatus(_this2.status_all.PAYMENT_COMPLETED);
                      var intervalHandler = setInterval(function () {
                        if (_this2.status === _this2.status_all.PAYMENT_COMPLETED) {
                          _this2.itemDelivery();
                          clearInterval(intervalHandler);
                        }
                      }, 1000);
                      return false;
                    });
                  }
                },
                itemDelivery: function itemDelivery() {
                  var _this3 = this;
                  if (this.status === this.status_all.PAYMENT_COMPLETED) {
                    this.changePaymentStatus(this.status_all.ITEM_DELIVERY);
                    this.waitingFor(function (_ref9) {
                      var tx_status = _ref9.tx_status;
                      if ([stampApiForWeb.STAMP_STATUS_CODE.ISSUED, stampApiForWeb.STAMP_STATUS_CODE.VERIFIED].includes(tx_status)) {
                        // 지정한 STATUS에서 상태 지속 점검
                        return true;
                      }
                      _this3.changePaymentStatus(_this3.status_all.ITEM_DELIVERY_COMPLETED);
                      return false;
                    });
                  }
                },
                start: function start() {
                  var newTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                  if (validUxMode === 'redirect') {
                    window.location.href = this.payurl;
                    return;
                  }
                  if (this.status !== this.status_all.READY) {
                    console.warn('current payment status is not ready.');
                    return null;
                  }
                  this.payment();
                  var windowHandler = window.open(this.payurl, newTab ? '_blank' : undefined);
                  return windowHandler;
                },
                cancel: function cancel() {
                  if ([this.status_all.ITEM_DELIVERY, this.status_all.PAYMENT, this.status_all.PAYMENT_COMPLETED].includes(this.status)) {
                    this.changePaymentStatus(this.status_all.CANCEL);
                  }
                }
              });
            case 91:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[77, 86]]);
      }));
      function billingPurchase() {
        return _billingPurchase.apply(this, arguments);
      }
      return billingPurchase;
    }(),
    /**
     * 구매내역 페이지로 이동합니다.
     * 
     * @description
     * - 사용자의 구매내역을 확인할 수 있는 페이지를 새 탭에서 열거나 현재 페이지에서 이동합니다.
     * - 현재 JPPC 마켓만 지원하며, gid 파라미터 유무에 따라 노출되는 구매내역 범위가 달라집니다.
     * 
     * JPPC 마켓 - gid에 따른 구매내역 범위:
     * - gid 전달 시: 해당 게임 서비스별 구매내역 노출
     * - gid 미전달 시: JPPC-INPAY 전체 구매내역 노출
     * 
     * @param {Object} [params={}] - 구매내역 페이지 열기 옵션
     * @param {string} [params.webToken] - 웹 토큰 (미전달 시 window.inface.auth.webToken 사용)
     * @param {string} [params.uxMode='newTab'] - 페이지 열기 방식 ('newTab' | 'redirect')
     * @param {string} [params.gid] - 게임 서비스 ID
     * 
     * @returns {Promise<void|{error: string}>} 성공 시 undefined, 에러 발생 시 에러 객체 반환
     * 
     * @example
     * 전체 구매내역 보기
     * await inpay.openPurchaseHistory()
     * 특정 게임 서비스의 구매내역만 보기
     * await inpay.openPurchaseHistory({ gid: '12345' })
     */
    openPurchaseHistory: function () {
      var _openPurchaseHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _window$inface9, _window$inface10;
        var _ref10,
          webToken,
          uxMode,
          gid,
          validGid,
          insignEnv,
          validUxMode,
          SUPPORTED_UX_MODES,
          message,
          validWebToken,
          _message10,
          market,
          _message11,
          validClientId,
          gtableInfo,
          _message12,
          validUrl,
          _message13,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref10 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, webToken = _ref10.webToken, uxMode = _ref10.uxMode, gid = _ref10.gid;
              validGid = gid || '';
              insignEnv = ((_window$inface9 = window.inface) === null || _window$inface9 === void 0 || (_window$inface9 = _window$inface9.auth) === null || _window$inface9 === void 0 ? void 0 : _window$inface9.env) || 'live';
              validUxMode = uxMode || UX_MODE.NEW_TAB;
              SUPPORTED_UX_MODES = [UX_MODE.NEW_TAB, UX_MODE.REDIRECT];
              if (SUPPORTED_UX_MODES.includes(validUxMode)) {
                _context6.next = 9;
                break;
              }
              message = "Inpay: uxMode must be ".concat(SUPPORTED_UX_MODES.join(' or '));
              console.error(message);
              return _context6.abrupt("return", {
                error: message
              });
            case 9:
              validWebToken = webToken || ((_window$inface10 = window.inface) === null || _window$inface10 === void 0 || (_window$inface10 = _window$inface10.auth) === null || _window$inface10 === void 0 ? void 0 : _window$inface10.webToken);
              if (validWebToken) {
                _context6.next = 14;
                break;
              }
              _message10 = 'Inpay: web token is undefined. please signin with insign service.';
              console.error(_message10);
              return _context6.abrupt("return", {
                error: _message10
              });
            case 14:
              if (inpayLocale.isSupportedMarket(validWebToken, inpayLocale.FEATURE_ENUM.PURCHASE_HISTORY)) {
                _context6.next = 19;
                break;
              }
              market = inpayLocale.getMarketFromWebToken(validWebToken);
              _message11 = "Inpay: ".concat(market, " is not supported market");
              console.error(_message11);
              return _context6.abrupt("return", {
                error: _message11
              });
            case 19:
              if (!validGid) {
                _context6.next = 28;
                break;
              }
              _context6.next = 22;
              return InfaceEnv.GTABLE.get(validGid, insignEnv);
            case 22:
              gtableInfo = _context6.sent;
              validClientId = gtableInfo.game_client_id;
              if (validClientId) {
                _context6.next = 28;
                break;
              }
              _message12 = 'Inpay: client id is undefined. Check Client value in parameter or gtable of inface console.';
              console.error(_message12);
              return _context6.abrupt("return", {
                error: _message12
              });
            case 28:
              validUrl = purchaseHistory.createUrl({
                webToken: validWebToken,
                clientId: validClientId
              });
              if (validUrl) {
                _context6.next = 33;
                break;
              }
              _message13 = 'Inpay: purchase history url is not defined';
              console.error(_message13);
              return _context6.abrupt("return", {
                error: _message13
              });
            case 33:
              if (validUxMode === UX_MODE.NEW_TAB) {
                window.open(validUrl, '_blank');
              } else {
                window.location.href = validUrl;
              }
            case 34:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function openPurchaseHistory() {
        return _openPurchaseHistory.apply(this, arguments);
      }
      return openPurchaseHistory;
    }(),
    // 결제 이후 지급 실패될 경우 복구를 위한 API
    restorePurchase: function () {
      var _restorePurchase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _window$inface11, _window$inface12;
        var _ref11,
          gid,
          webToken,
          validGid,
          validWebToken,
          message,
          market,
          _message14,
          _stampResp$restore_st,
          vendorResp,
          stampResp,
          restoreList,
          _callWithRetry,
          prevStatus,
          _iterator,
          _step,
          stamp_id,
          _args8 = arguments;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _ref11 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, gid = _ref11.gid, webToken = _ref11.webToken;
              validGid = gid || ((_window$inface11 = window.inface) === null || _window$inface11 === void 0 || (_window$inface11 = _window$inface11.auth) === null || _window$inface11 === void 0 ? void 0 : _window$inface11.gid);
              validWebToken = webToken || ((_window$inface12 = window.inface) === null || _window$inface12 === void 0 || (_window$inface12 = _window$inface12.auth) === null || _window$inface12 === void 0 ? void 0 : _window$inface12.webToken); // TODO: webtoken 및 market 확인 공통화
              if (validWebToken) {
                _context8.next = 7;
                break;
              }
              message = 'Inpay: web token is undefined. please signin with insign service.';
              console.error(message);
              return _context8.abrupt("return", {
                error: message
              });
            case 7:
              market = inpayLocale.getMarketFromWebToken(validWebToken);
              if (inpayLocale.isSupportedMarket(validWebToken, inpayLocale.FEATURE_ENUM.PAYMENT)) {
                _context8.next = 12;
                break;
              }
              _message14 = "Inpay: ".concat(market, " is not supported market");
              console.error(_message14);
              return _context8.abrupt("return", {
                error: _message14
              });
            case 12:
              _context8.prev = 12;
              _context8.next = 15;
              return stampApiForWeb.restoreVendor({
                gid: validGid,
                market: market,
                webToken: validWebToken
              });
            case 15:
              vendorResp = _context8.sent;
              _context8.next = 18;
              return stampApiForWeb.restoreStamp({
                gid: validGid,
                webToken: validWebToken
              });
            case 18:
              stampResp = _context8.sent;
              restoreList = (_stampResp$restore_st = stampResp === null || stampResp === void 0 ? void 0 : stampResp.restore_stamps) !== null && _stampResp$restore_st !== void 0 ? _stampResp$restore_st : [];
              if (!(restoreList.length === 0)) {
                _context8.next = 22;
                break;
              }
              return _context8.abrupt("return", StampError.CODE_BILLING_RESTORE_EMPTY_TRANSACTIONS_ERR);
            case 22:
              _callWithRetry = /*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(stamp_id) {
                  var retry,
                    _yield$stampApiForWeb,
                    tx_status,
                    _args7 = arguments;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        retry = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 0;
                        _context7.prev = 1;
                        _context7.next = 4;
                        return stampApiForWeb.getStatus({
                          param: {
                            stamp_id: stamp_id,
                            token: validWebToken
                          }
                        });
                      case 4:
                        _yield$stampApiForWeb = _context7.sent;
                        tx_status = _yield$stampApiForWeb.tx_status;
                        if (!(stampApiForWeb.STAMP_STATUS_CODE.FINISHED === tx_status)) {
                          _context7.next = 8;
                          break;
                        }
                        return _context7.abrupt("return", tx_status);
                      case 8:
                        _context7.next = 13;
                        break;
                      case 10:
                        _context7.prev = 10;
                        _context7.t0 = _context7["catch"](1);
                        console.error("API call error( retry ".concat(retry, "):"), _context7.t0);
                      case 13:
                        if (!(retry >= 4)) {
                          _context7.next = 15;
                          break;
                        }
                        throw new Error("Retry limit exceeded for stamp_id: ".concat(stamp_id));
                      case 15:
                        _context7.next = 17;
                        return new Promise(function (resolve) {
                          return setTimeout(resolve, 2000);
                        });
                      case 17:
                        return _context7.abrupt("return", _callWithRetry(stamp_id, retry + 1));
                      case 18:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7, null, [[1, 10]]);
                }));
                return function callWithRetry(_x) {
                  return _ref12.apply(this, arguments);
                };
              }();
              _context8.prev = 23;
              _iterator = _createForOfIteratorHelper(restoreList);
              _context8.prev = 25;
              _iterator.s();
            case 27:
              if ((_step = _iterator.n()).done) {
                _context8.next = 34;
                break;
              }
              stamp_id = _step.value.stamp_id;
              _context8.next = 31;
              return _callWithRetry(stamp_id);
            case 31:
              prevStatus = _context8.sent;
            case 32:
              _context8.next = 27;
              break;
            case 34:
              _context8.next = 39;
              break;
            case 36:
              _context8.prev = 36;
              _context8.t0 = _context8["catch"](25);
              _iterator.e(_context8.t0);
            case 39:
              _context8.prev = 39;
              _iterator.f();
              return _context8.finish(39);
            case 42:
              _context8.next = 49;
              break;
            case 44:
              _context8.prev = 44;
              _context8.t1 = _context8["catch"](23);
              if (!(prevStatus === stampApiForWeb.STAMP_STATUS_CODE.FINISHED)) {
                _context8.next = 48;
                break;
              }
              return _context8.abrupt("return", StampError.CODE_BILLING_RESTORE_PARTIAL_DELIVERY_ERR);
            case 48:
              return _context8.abrupt("return", StampError.CODE_BILLING_RESTORE_DELIVERY_ERR);
            case 49:
              return _context8.abrupt("return", {
                error_code: 0,
                error: '',
                error_description: ''
              });
            case 52:
              _context8.prev = 52;
              _context8.t2 = _context8["catch"](12);
              return _context8.abrupt("return", _context8.t2);
            case 55:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[12, 52], [23, 44], [25, 36, 39, 42]]);
      }));
      function restorePurchase() {
        return _restorePurchase.apply(this, arguments);
      }
      return restorePurchase;
    }()
  };
}